import {
  GET_ANNOUNCEMENTS_REQUEST,
  GET_ANNOUNCEMENTS_FAILURE,
  GET_ANNOUNCEMENTS_SUCCESS,
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_FAILURE,
  CREATE_ANNOUNCEMENT_SUCCESS,
  GET_ONE_ANNOUNCEMENT_REQUEST,
  GET_ONE_ANNOUNCEMENT_SUCCESS,
  GET_ONE_ANNOUNCEMENT_FAILURE,
  UPDATE_ANNOUNCEMENT_SUCCESS
} from "src/actions/AnnouncementActions";

import produce from "immer";
import {UPDATE_SUPPLIER_FAILURE} from "../actions/supplierActions";

const initialState = {
  announcements: [],
  loadingGetAnnouncements: false,
  announcement: {},
  loadingGetOneAnnouncement: false,
  loadingCreateAnnouncement: false,
  loadingUpdateAnnouncement: false
};

const announcementReducer = (state = initialState, action) => {
  switch (action.type) {
    // Case Get Suppliers
    case GET_ANNOUNCEMENTS_REQUEST: {
      return produce(state, (draft) => {
        draft.announcements = [];
        draft.loadingGetAnnouncements = true;
      });
    }

    case GET_ANNOUNCEMENTS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.announcements = response;
        draft.loadingGetAnnouncements = false;
      });
    }

    case GET_ANNOUNCEMENTS_FAILURE: {
      return produce(state, (draft) => {
        // Maybe supplier error
        draft.loadingGetAnnouncements = false;
      });
    }

    case CREATE_ANNOUNCEMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingCreateAnnouncement = true;
      });
    }

    case CREATE_ANNOUNCEMENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.announcements = draft.announcements.concat(response);
        draft.loadingCreateAnnouncement = false;
      });
    }

    case CREATE_ANNOUNCEMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingCreateAnnouncement = false;
      });
    }

    case GET_ONE_ANNOUNCEMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingGetOneAnnouncement = true;
      });
    }

    case GET_ONE_ANNOUNCEMENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.announcement = response;
        draft.loadingGetOneAnnouncement = false;
      });
    }

    case GET_ONE_ANNOUNCEMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneAnnouncement = false;
      });
    }

    case UPDATE_ANNOUNCEMENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.announcement = response;
        draft.loadingUpdateAnnouncement = false;
      });
    }

    case UPDATE_SUPPLIER_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateAnnouncement = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default announcementReducer;
